import { useState } from 'react'
import { useLogin } from '../../hooks/useLogin'

// styles
import styles from './Login.module.css'
import { Card, Dropdown, Form } from 'react-bootstrap';
import uobLogo from '../../media/uob.png'

export default function Login() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')
  const [userType, setUserType] = useState('student')
  const { login, error, isPending } = useLogin()


  const formatDate = (dateString) => {
    const dateArray = dateString.split('-')
    const day = dateArray[2]
    const month = dateArray[1]
    const year = dateArray[0]
    return `${day}/${month}/${year}`
  }

  const handleStudentSubmit = (e) => {
    e.preventDefault()
    login( (username +'@uob.edu.ly').trim(), formatDate(dateOfBirth).replace(/\//g, ''))
  }

  const handleTeacherSubmit = (e) => {
    e.preventDefault()
    login((username +'@uob.edu.ly').trim(), password)
  }

  const handleUserTypeChange = (e) => {
    setUserType(e.target.value)
  }

  

  return (
    
    <form className={styles['login-form']}>
      <div>
  <img className={styles['university-logo']} src={uobLogo} alt="University of Benghazi Logo" />
  </div>
  <Card  className="login-card">
  <Card.Header>تسجيل الدخول</Card.Header>
      <Card.Body>
      <label>
      <span> نوع المستخدم  </span>
      <Form.Select dir="rtl" value={userType} onChange={handleUserTypeChange} aria-label="Default select example">
      <option value={'student'}> طالب </option>
      <option value={'teacher'}> مرشد </option>
     </Form.Select> 
     </label>
      {userType === 'student' && (
        <>
          <label>
            <span>الرقم الدراسي:</span>
            <input
              type="text"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
            />
          </label>
          <label>
            <span>تاريخ الميلاد: </span>
            <input
                type="date"
                onChange={(e) => setDateOfBirth(e.target.value)}
                value={dateOfBirth}
            />
                {dateOfBirth && <span>تاريخ الميلاد {formatDate(dateOfBirth)}</span>}
          </label>
          {!isPending && (
            <button className="btn btn-dark" onClick={handleStudentSubmit}>
              تسجيل الدخول
            </button>
          )}
          {isPending && <button className="btn" disabled>جاري التحميل</button>}
        </>
      )}
      {userType === 'teacher' && (
        <>
          <label>
            <span>اسم المستخدم: </span>
            <input
              type="text"
              onChange={(e) => setUsername(e.target.value)}
              value={username}
            />
          </label>
          <label>
            <span>كلمة المرور: </span>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            
          </label>
          {!isPending && (
            <button className="btn btn-dark" onClick={handleTeacherSubmit}>
              تسجيل الدخول
            </button>
          )}
          {isPending && <button className="btn" disabled>جاري التحميل</button>}
        </>
      )}
      {error && <p>{error}</p>}
      </Card.Body>
              </Card>
    </form>
  )
}
